import {useState} from 'react';
import {Modal} from 'antd';
import styles from './LogoutConfirmModal.module.less';
import Button from '@/components/common/Button';
import {useModalStore} from '@/store/useModalStore';
import {fetchLogout} from '@/services';
import {clearAuthSession} from '@/services/authSession';
import {useTracking} from '@/services/tracking/context';
import {TrackEvents} from '@/services/tracking/constant';

const LogoutConfirmModal: React.FC = () => {
    const open = useModalStore((s) => s.logoutConfirmOpen);
    const toggleLogoutConfirm = useModalStore((s) => s.toggleLogoutConfirm);
    const [loading, setLoading] = useState(false);
    const {sendClickLog} = useTracking();

    const handleCancel = () => {
        toggleLogoutConfirm(false);
    };

    const handleLogout = async () => {
        sendClickLog({
            page: TrackEvents.PAGE_HOME,
            value: TrackEvents.LOGOUT_BTN,
        });
        setLoading(true);
        try {
            const data = await fetchLogout();
            if (data?.logoutUrl) {
                window.location.href = data.logoutUrl;
                return;
            }
            clearAuthSession();
        } finally {
            setLoading(false);
            toggleLogoutConfirm(false);
        }
    };

    return (
        <Modal
            open={open}
            onCancel={handleCancel}
            footer={null}
            width={440}
            centered
            className={styles.logoutConfirm}
            title={
                <span className={styles.modalTitle}>
                    <img
                        src="https://now.bdstatic.com/stash/v1/01e9009/mangaflow-fe/9896fde/首页/icon-warning.png"
                        alt=""
                        className={styles.warningIcon}
                    />
                    确认退出
                </span>
            }
            styles={{
                body: {
                    padding: 0,
                },
                mask: {
                    backdropFilter: 'blur(5px)',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                },
            }}
        >
            <div className={styles.body}>确定要退出登录吗？退出后将无法使用创作功能。</div>
            <div className={styles.footer}>
                <Button className={styles.footerBtn} onClick={handleCancel}>
                    取消
                </Button>
                <Button
                    type="primary"
                    className={styles.footerBtn}
                    onClick={handleLogout}
                    loading={loading}
                >
                    确定
                </Button>
            </div>
        </Modal>
    );
};

export default LogoutConfirmModal;
